import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import Form from "./Form";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPeriods, getQuotaStatus, getUserCountries,reset } from "./quotaSlice";
import Table from "./Table";
import QuotaDetailsTable from "./QuotaDetailsTable";
import GraphModal from "./GraphModal";
import ButtonGroup from "./ButtonGroup";
import RejectSelectedModal from "./RejectSelectedModal";
import ApproveWithCommentModal from "./ApproveWithCommentModal";
import RejectSingleModal from "./RejectSingleModal";
import Comments from "./Comments";
import ApproveSingleWithCommentModal from "./ApproveSingleWithCommentModal";
import MessageForQuota from "./MessageForQuota";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function Quota() {
	const dispatch = useDispatch();
	const state = useSelector((state) => state.quota);
	const {
		isLoading,
		countries,
		quotaStatusList,
		periods,
		quotaForApprovalTable,
		quotaDetailsTable,
		quotaForApproval,
	} = state;

	useEffect(() => {
		dispatch(reset("refresh"));
		if (countries.length === 0) {
			dispatch(getUserCountries());
		}
		if (quotaStatusList.length === 0) {
			dispatch(getQuotaStatus());
		}
		if (periods.length === 0) {
			dispatch(getPeriods());
		}
	}, []);

	return (
		<Box>
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>
			<Box>
				<MessageForQuota />
			</Box>
			<CollapseSection title="Search for quota">
			<Form />
			{quotaForApproval?.length >0 ? <Table /> : null}
         <GraphModal />
         <RejectSelectedModal/>
		 <RejectSingleModal/>
         <ApproveWithCommentModal/>
		 <ApproveSingleWithCommentModal/>
		 {quotaForApproval?.length >0 ?  <ButtonGroup/>: null}
		 </CollapseSection>
			{quotaDetailsTable !== null ? <QuotaDetailsTable /> : null}
		<CollapseSection title="Comments and attachments">	
         <Comments/>
		 </CollapseSection>
		</Box>
	);
}
